export default {
  curveEditor: {
    saveCurrentCurve: '保存当前曲线',
    saveCurve: '保存曲线',
    curveName: '曲线名称',
    cancel: '取 消',
    confirm: '确 定',
    deleteKeyFrame: '删除关键帧',
    auto: 'AUTO',
    freeSmooth: 'FREE_SMOOTH',
    flat: 'FLAT',
    broken: 'BROKEN',
    linear: 'LINEAR',
    close: '关 闭',
    save: '保 存',
    dialogProps: {
      title: '曲线编辑器',
    },
    curveNameIsEmpty: '曲线名称不能为空',
    saveCurveSuccess: '保存曲线成功',
  },
  animationCollection: {
    play: '播放',
    stop: '停止',
    save: '保存',
    close: '收起',
    playAllAnimation: '播放全部动画',
    deleteSuccess: '删除成功',
    stopAnimation: '停止动画播放',
  },
  animationForm: {
    duration: '持续时间',
    delay: '延迟时间',
    style: '循环次数',
    playOnAwake: '自动播放',
    animationName: '动画名称',
    moveAxis: '位移轴',
    autoEndTime: '自动结束时间',
    loop: '循环',
    distanceX: '距离X',
    distanceY: '距离Y',
    rebound: '弹性',
    trialTimes: '试玩次数',
  },
  qcPoint: {
    setPointValue: '设置成当前值',
    positionMap: {
      from: '起始位置',
      to: '结束位置',
    },
    scaleMap: {
      from: '起始比例',
      to: '结束比例',
    },
  },
  animationColor: {
    colorLabel: {
      from: '开始颜色',
      to: '结束颜色',
    },
  },
  tweenPosition: {
    show: '编辑结束位置',
    hide: '保存结束位置',
  },
  circular: {
    once: '播放1次',
    loop: '单向循环',
    pingPong: '双向循环',
  },
  animationType: {
    base: '通用',
    in: '进场动画',
    out: '退场动画',
    strong: '强调动画',
  },
  animationTag: [
    '透明度变化',
    '平移出现',
    '原地缩放出现',
    '放大滑入',
    '弹动出现',
    '展开',
    '原地旋转出现',
    '滚动出现',
    '透明度变化',
    '平移消失',
    '原地缩放出现',
    '缩小滑出',
    '弹动消失',
    '折叠',
    '原地旋转消失',
    '滚动消失',
    '缩放',
    '闪烁',
    '来回',
    '弹性',
    '摇摆',
    '旋转',
    '位移缩放',
  ],
  tweenLabel: {
    alpha: '透明度',
    position: '位移',
    rotation: '旋转角度',
    scale: '缩放',
    color: '颜色变化',
  },
  switchAnimation: '替换动画',
  scriptManager: {
    animationCurve: '变化曲线',
    handArea: '手势区域',
  },
  board: '手势区域',
}
